import identity from "lodash/fp/identity";

class StationsHeatmapPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default StationsHeatmapPageTransform;



// WEBPACK FOOTER //
// ./src/pages/stationsHeatmap/stationsHeatmap.transforms.js